"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTypes = void 0;
var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["AccountUpdated"] = "AccountUpdated";
    NotificationTypes["AccountMemberCreated"] = "AccountMemberCreated";
    NotificationTypes["AccountMemberUpdated"] = "AccountMemberUpdated";
    NotificationTypes["ENSNodeCreated"] = "ENSNodeCreated";
    NotificationTypes["ENSNodeUpdated"] = "ENSNodeUpdated";
    NotificationTypes["GatewayBatchCreated"] = "GatewayBatchCreated";
    NotificationTypes["GatewayBatchUpdated"] = "GatewayBatchUpdated";
    NotificationTypes["P2PPaymentChannelCreated"] = "P2PPaymentChannelCreated";
    NotificationTypes["P2PPaymentChannelUpdated"] = "P2PPaymentChannelUpdated";
    NotificationTypes["P2PPaymentDepositCreated"] = "P2PPaymentDepositCreated";
    NotificationTypes["P2PPaymentDepositUpdated"] = "P2PPaymentDepositUpdated";
    NotificationTypes["PaymentHubCreated"] = "PaymentHubCreated";
    NotificationTypes["PaymentHubUpdated"] = "PaymentHubUpdated";
    NotificationTypes["PaymentHubBridgeCreated"] = "PaymentHubBridgeCreated";
    NotificationTypes["PaymentHubBridgeUpdated"] = "PaymentHubBridgeUpdated";
    NotificationTypes["PaymentHubDepositCreated"] = "PaymentHubDepositCreated";
    NotificationTypes["PaymentHubDepositUpdated"] = "PaymentHubDepositUpdated";
    NotificationTypes["PaymentHubPaymentCreated"] = "PaymentHubPaymentCreated";
    NotificationTypes["TransactionUpdated"] = "TransactionUpdated";
})(NotificationTypes = exports.NotificationTypes || (exports.NotificationTypes = {}));
